<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <div class="white_block">
        <enterprise-intern-form @load="loadFormData" @submit="submitInternAply" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EnterpriseInternForm from './InternForm'
export default {
  name: 'EnterprisesInternApplyContent',
  components: {
    EnterpriseInternForm
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentInternStatusGetter',
      'currentEnterpriseGetter',
      'pastInternBasicInfoGetter',
    ]),
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseInternForm',
      'getEnterpriseByToken',
      'sendEnterpriseInternForm',
      'getPassEnterpriseInternForm'
    ]),
    async loadFormData(enter_area) {
      await this.getPassEnterpriseInternForm();
      await this.getEnterpriseInternForm();
      await this.getEnterpriseByToken();
      if (this.currentInternStatusGetter == 'unapplied_or_expired') {
        if (this.pastInternBasicInfoGetter.internBasicInfo != null) {

          console.log(this.pastInternBasicInfoGetter.internBasicInfo);
          enter_area.set_form_data({
            account: this.pastInternBasicInfoGetter.internBasicInfo.account,
            name: this.pastInternBasicInfoGetter.internBasicInfo.name,
            en_name: this.pastInternBasicInfoGetter.internBasicInfo.en_name,
            principal: this.pastInternBasicInfoGetter.internBasicInfo.principal,
            contact: this.pastInternBasicInfoGetter.internBasicInfo.contact,
            phone: this.pastInternBasicInfoGetter.internBasicInfo.phone,
            address: this.pastInternBasicInfoGetter.internBasicInfo.address,
            email: this.pastInternBasicInfoGetter.internBasicInfo.email,
            fax: this.pastInternBasicInfoGetter.internBasicInfo.fax,
            staff_count: this.pastInternBasicInfoGetter.internBasicInfo.staff_count,
            introduction: this.pastInternBasicInfoGetter.internBasicInfo.introduction,
            job: this.pastInternBasicInfoGetter.internBasicInfo.job,
            turnover: +this.pastInternBasicInfoGetter.internBasicInfo.turnover,
            vacation_way: this.pastInternBasicInfoGetter.internBasicInfo.vacation_way,
          });
        } else {
          enter_area.set_form_data({
            account: this.currentEnterpriseGetter.enterprise_gui_number,
            name: this.currentEnterpriseGetter.enterprise_name,
            en_name: this.currentEnterpriseGetter.enterprise_name_en,
            principal: this.currentEnterpriseGetter.enterprise_owner,
            contact: this.currentEnterpriseGetter.enterprise_hr_contact_person,
            phone: this.currentEnterpriseGetter.enterprise_hr_contact_tel,
            address: this.currentEnterpriseGetter.enterprise_address,
            email: this.currentEnterpriseGetter.enterprise_hr_contact_email,
            fax: this.currentEnterpriseGetter.enterprise_fax,
            staff_count: this.currentEnterpriseGetter.enterprise_employee_number,
            introduction: this.currentEnterpriseGetter.enterprise_introduction,
          });
        }

      }
      else if (this.currentInternStatusGetter == 'under_review') {
        this.$router.push({ path: '/enterprises' });
      }
      else if (this.currentInternStatusGetter == 'is_enabled') {
        this.$router.push({ path: '/enterprises/intern/intern-record' });
      }
      this.togglePageLoader(false);
    },
    submitInternAply(form_data) {
      this.sendEnterpriseInternForm(form_data).then((result) => {
        this.$router.push({ path: '/enterprises' })
      });
    },
  }
}
</script>
